import { useMemo } from 'react';
import { useExpiredVmTime, useStartTimeVm } from 'src/common/hooks';
import { RunningInstance } from 'src/common/interfaces/instances';
import { RoomTask } from 'src/common/interfaces/tasks';
import { Machine } from './machine';
type TargetMachineProps = {
  instance: RunningInstance;
  roomCode: string;
  hasMultipleVMs: boolean;
  tasks?: RoomTask[];
};
export const TargetMachine = ({
  instance,
  roomCode,
  hasMultipleVMs,
  tasks
}: TargetMachineProps) => {
  const {
    formattedStartTimeLeft,
    hideIpAddress
  } = useStartTimeVm(instance);
  const targetInstanceIPValue = hideIpAddress ? `Shown in ${formattedStartTimeLeft}` : `${instance.internalIP ?? ''}`;
  const {
    formattedTime
  } = useExpiredVmTime(instance.expires, () => {});
  const activeVmTask = useMemo(() => hasMultipleVMs ? tasks?.find(task => task.uploadId === instance.uploadId) : undefined, [hasMultipleVMs, instance.uploadId, tasks]);
  return <Machine variant="target" ipAddress={targetInstanceIPValue} hideIpAddress={hideIpAddress} title={instance.title} expires={formattedTime} runningInstance={instance} roomCode={roomCode} activeVmTask={activeVmTask} data-sentry-element="Machine" data-sentry-component="TargetMachine" data-sentry-source-file="target-machine.tsx" />;
};